/* eslint-disable prettier/prettier */
import React from "react";
import { SubscriptionTestimonial } from "./subscription-testimonial";
import { SubscriptionCollection } from "./subscription-collection";
import { SubscriptionBlocks } from "./subscription-blocks";
import { Features } from "./features";
import { SubscriptionPlaylist } from "./subscription-playlist";
import { Faq } from "./faq";
import { SubscriptionExplained } from "./subscription-explained";
// import "./subscription-page.m.css";
export const SubscriptionPage = props => (
  <div>
    <SubscriptionBlocks {...props} />
    <div>
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
      <br /><br /><br /><br />
      <Features />
    </div>

    <SubscriptionTestimonial {...props} />
    <br />
    <SubscriptionCollection {...props} />
    <SubscriptionPlaylist />
    <SubscriptionExplained {...props} />
    <Faq />
  </div>
);
